import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ChangeOwnershipCommand extends AbstractConfDataCommand {

  toWorkGroupId: number
  applyToAllRevisions: boolean;

}